module.exports = __webpack_public_path__ + "img/commi_mob_dia.png";